const currencies = [
    'adax',
    'ardana',
    'kick-io',
    'doex',
    'yayswap',
    'ravendex',
    'revuto',
    'world-mobile-token'
    
];
export {currencies}